import {IRecommendedOffer} from "../../../offer/types/IRecommendedOffer";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";

export const isRecommendationRecommendedProperty = (
    application: IRecommendedProperty | IRecommendedOffer | IPropertyDetail
): application is IRecommendedProperty | IPropertyDetail => {
    return "offer" in application;
};
